export function parseCSVLine(line: string): string[] {
  const fields: string[] = [];
  let field = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        field += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      fields.push(field);
      field = '';
    } else {
      field += char;
    }
  }

  fields.push(field);
  return fields;
}

/**
 * Tokenize an entire CSV document into records (rows of fields).
 *
 * Unlike a naive `split('\n')`, this correctly handles:
 * - quoted fields containing commas, quotes (`""` escaping) and embedded newlines
 *   (product descriptions frequently contain line breaks)
 * - both `\r\n` (the format produced by the exporter) and `\n` line endings
 * - a leading UTF-8 BOM (the exporter prepends `\uFEFF`)
 */
export function parseCSVRecords(content: string): string[][] {
  let text = content;
  if (text.charCodeAt(0) === 0xfeff) {
    text = text.slice(1);
  }

  const records: string[][] = [];
  let fields: string[] = [];
  let field = '';
  let inQuotes = false;

  const endField = () => {
    fields.push(field);
    field = '';
  };
  const endRecord = () => {
    endField();
    records.push(fields);
    fields = [];
  };

  for (let i = 0; i < text.length; i++) {
    const char = text[i];

    if (inQuotes) {
      if (char === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += char;
      }
      continue;
    }

    if (char === '"') {
      inQuotes = true;
    } else if (char === ',') {
      endField();
    } else if (char === '\r') {
      if (text[i + 1] === '\n') i++;
      endRecord();
    } else if (char === '\n') {
      endRecord();
    } else {
      field += char;
    }
  }

  // Flush any trailing field/record that wasn't terminated by a newline.
  if (field !== '' || fields.length > 0) {
    endRecord();
  }

  return records;
}